import React from "react"

function ComplaintsDisputesStatsCard() {
    return (
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {/* Complaints Card */}
            <div className="bg-white rounded-lg shadow-md p-6">
                <h2 className="text-xl font-semibold mb-1">Complaints</h2>
                <p className="text-gray-500 text-sm mb-6">
                    Citizen Feedback & Grievance Monitoring
                </p>

                <div className="flex items-center gap-4 mb-6">
                    <div className="bg-purple-100 text-purple-600 font-bold text-2xl rounded-xl px-4 py-2">
                        80
                    </div>
                    <div>
                        <p className="font-semibold">Total Complaints Filed</p>
                        <p className="text-sm text-gray-500">Filed Complaints to Date</p>
                    </div>
                </div>

                {/* Open */}
                <div className="mb-4">
                    <div className="flex justify-between text-sm mb-1">
                        <span>Open Complaints</span>
                        <span className="text-yellow-600 font-medium">25 (31.25%)</span>
                    </div>
                    <div className="w-full bg-gray-200 rounded-full h-2">
                        <div className="bg-yellow-400 h-2 rounded-full w-[31%]" />
                    </div>
                </div>

                {/* Resolved */}
                <div className="mb-4">
                    <div className="flex justify-between text-sm mb-1">
                        <span>Resolved Complaints</span>
                        <span className="text-blue-600 font-medium">48 (60.0%)</span>
                    </div>
                    <div className="w-full bg-gray-200 rounded-full h-2">
                        <div className="bg-blue-500 h-2 rounded-full w-[60%]" />
                    </div>
                </div>

                {/* Closed */}
                <div>
                    <div className="flex justify-between text-sm mb-1">
                        <span>Closed Complaints</span>
                        <span className="text-green-600 font-medium">7 (8.75%)</span>
                    </div>
                    <div className="w-full bg-gray-200 rounded-full h-2">
                        <div className="bg-green-500 h-2 rounded-full w-[9%]" />
                    </div>
                </div>
            </div>

            {/* Disputes Card */}
            <div className="bg-white rounded-lg shadow-md p-6">
                <h2 className="text-xl font-semibold mb-1">Disputes</h2>
                <p className="text-gray-500 text-sm mb-6">
                    Mediation Progress & Case Resolutions
                </p>

                <div className="flex items-center gap-4 mb-6">
                    <div className="bg-red-100 text-red-600 font-bold text-2xl rounded-xl px-4 py-2">
                        168
                    </div>
                    <div>
                        <p className="font-semibold">Total Dispute Cases</p>
                        <p className="text-sm text-gray-500">Dispute Cases on Record</p>
                    </div>
                </div>

                {/* Ongoing */}
                <div className="mb-4">
                    <div className="flex justify-between text-sm mb-1">
                        <span>Ongoing Cases</span>
                        <span className="text-blue-600 font-medium">32 (19.05%)</span>
                    </div>
                    <div className="w-full bg-gray-200 rounded-full h-2">
                        <div className="bg-blue-500 h-2 rounded-full w-[19%]" />
                    </div>
                </div>

                {/* Resolved */}
                <div>
                    <div className="flex justify-between text-sm mb-1">
                        <span>Resolved Cases</span>
                        <span className="text-green-600 font-medium">136 (80.95%)</span>
                    </div>
                    <div className="w-full bg-gray-200 rounded-full h-2">
                        <div className="bg-green-500 h-2 rounded-full w-[81%]" />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ComplaintsDisputesStatsCard
